import { ILocLinkifierModel } from '../filters/LocLinkifierFilter';
import { SolrErrorCode } from '../helpers/ErrorCodes';
import { Module } from '../Module';
import { getContentRootStateName } from '../services/ContentUrl';
import { ServerService } from '../services/ServerService';

//Either detailsLocKey or detailsLinkifierModel should be specified in the IErrorStateParams.
//If both are given, detailsLocKey takes precedence.
export interface IErrorStateParams {
  detailsLocKey?: string;
  detailsLinkifierModel?: string; //stringified JSON object because state params must be strings
  redirectState?: string;
  redirectLocKey?: string;
  redirectSiteUrlName?: string;
  errorCode?: any;
}

export interface IErrorScope extends ng.IScope {
  detailsLocKey: string;
  detailsLinkifierModel: () => ILocLinkifierModel;
  redirectUrl: string;
  redirectLocKey: string;
}

export class ErrorCtrl {
  public static StateParamKeys = {
    DetailsLocKey: 'detailsLocKey',
    DetailsLinkifierModel: 'detailsLinkifierModel',
    RedirectState: 'redirectState',
    RedirectLocKey: 'redirectLocKey',
    RedirectSiteUrlName: 'redirectSiteUrlName'
  };

  public static $inject = [
    '$scope',
    '$state',
    '$stateParams',
    'ServerService'
  ];

  constructor(
    $scope: IErrorScope,
    $state: ng.ui.IStateService,
    $stateParams: IErrorStateParams,
    server: ServerService
  ) {
    // attempt to coerce to number
    const error: number = +$stateParams.errorCode;
    if (!error) {
      const redirectState = $stateParams.redirectState || getContentRootStateName();
      const redirectSiteUrlName = $stateParams.redirectSiteUrlName || server.sessionSiteUrlName();
      $scope.redirectLocKey = $stateParams.redirectLocKey || 'backToContent';
      let redirectHrefStateParams;

      if($stateParams.detailsLinkifierModel) {
        $scope.detailsLinkifierModel = () => JSON.parse($stateParams.detailsLinkifierModel);
        const currentUser = server.sessionUserInfo();
        redirectHrefStateParams = {
          domainName: currentUser.domainName,
          username: currentUser.username,
          siteUrlName: redirectSiteUrlName
        };
      } else {
        $scope.detailsLocKey = $stateParams.detailsLocKey || 'pageDoesNotExist';
        redirectHrefStateParams = { siteUrlName: redirectSiteUrlName };
      }

      $scope.redirectUrl = $state.href(redirectState, redirectHrefStateParams);
    } else {
      switch (error) {
        case SolrErrorCode.SolrDisabled:
        case SolrErrorCode.SolrCommunicationError:
          $scope.redirectLocKey = null;
          $scope.redirectUrl = null;
          $scope.detailsLocKey = 'serverDown';
          break;
        default:
          $scope.redirectLocKey = null;
          $scope.redirectUrl = null;
          $scope.detailsLocKey = $stateParams.detailsLocKey || 'pageDoesNotExist';
          break;
      }
    }
  }
}

Module.instance().controller('ErrorCtrl', ErrorCtrl);
